import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "technical-form" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "type" }
const _hoisted_9 = {
  key: 0,
  class: "empty"
}

import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";
import { svgIcon, baseInput } from "@/common/components";

import { sampleList } from "@/common/api/rest/sample";
import { evaluationSampleList } from "@/common/api/rest/evaluation";

import type { SampleType } from "@/common/types/sample";


export default /*@__PURE__*/_defineComponent({
  __name: 'sample',
  props: {
    title: {},
    accountId: {},
    evaluationId: {},
    status: {},
    unic: { type: Boolean },
    ids: {}
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const selected = ref<SampleType[]>([]);
const listData = ref<SampleType[]>([]);
const inputSearch = ref<string | null>("");

function searchEvaluation() {
  if (!props.evaluationId) return;

  evaluationSampleList(props.evaluationId, {
    search: inputSearch.value as string,
    status: props.status || null,
    full: true,
    page: 0,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        listData.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function searchSamples() {
  if (!props.accountId) return;

  sampleList(props.accountId, {
    search: inputSearch.value as string,
    status: props.status || "",
    full: true,
    page: 0,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        listData.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function search() {
  if (props.evaluationId) {
    searchEvaluation();
    return;
  }

  searchSamples();
}

function isDisabled(data: SampleType) {
  if (props.ids?.includes(data.sample_id)) {
    return true;
  }

  if (data.status === "IN_USE") {
    return true;
  }

  return false;
}

function select(data: SampleType) {
  if (isDisabled(data)) {
    return;
  }

  if (props.unic) {
    selected.value = [data];
  } else {
    if (selected.value.find((sl) => sl.sample_id === data.sample_id)) {
      selected.value = selected.value.filter(
        (sl) => sl.sample_id !== data.sample_id,
      );
    } else {
      selected.value.push(data);
    }
  }

  emit("update-data", selected.value);
}

onMounted(() => {
  search();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(baseInput), {
        modelValue: inputSearch.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputSearch).value = $event)),
        background: "#fff",
        color: "#000",
        placeholder: _unref(t)('common.labels.search'),
        "onKey:enter": _cache[2] || (_cache[2] = ($event: any) => (search()))
      }, {
        sufix: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(svgIcon), {
              icon: "search",
              size: "1.75rem",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (search()))
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.sample_id,
          class: _normalizeClass(["item", {
            active: selected.value.find((sl) => sl.sample_id === item.sample_id),
            disabled: isDisabled(item),
          }]),
          onClick: ($event: any) => (select(item))
        }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.code), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)
        ], 10, _hoisted_6))
      }), 128)),
      (listData.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)("common.texts.no_results")), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})